var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_109_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0H0.5V24H24.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_109_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5087 12.0236C21.5087 13.338 21.5181 14.6524 21.5087 15.9669C21.4899 18.793 19.3023 20.9994 16.4856 21.0087C13.8285 21.0181 11.1715 21.0181 8.50503 21.0087C5.68836 20.9994 3.49135 18.793 3.48196 15.9669C3.48196 13.3192 3.48196 10.6809 3.49135 8.03326C3.50074 5.2072 5.68836 3.00081 8.51442 2.99142C11.1715 2.98203 13.8285 2.98203 16.495 2.99142C19.3117 3.00081 21.4993 5.2072 21.5181 8.03326C21.5181 9.36649 21.5087 10.6903 21.5087 12.0236ZM12.5047 16.9997C15.2838 16.9997 17.4996 14.7651 17.4902 11.986C17.4808 9.22566 15.2744 7.01926 12.5047 7.00987C9.73498 6.99109 7.50042 9.21627 7.50042 11.9954C7.50042 14.7839 9.72559 16.9997 12.5047 16.9997ZM19.5088 6.01465C19.5182 5.48887 19.077 5.01942 18.5512 4.99126C18.0066 4.96309 17.5184 5.42315 17.509 5.97709C17.4996 6.50287 17.9409 6.97232 18.4667 7.00048C19.0112 7.01926 19.4995 6.5592 19.5088 6.01465Z",
    fill: "#354EB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4954 15.0098C10.8336 15.0098 9.49094 13.6578 9.49094 11.9866C9.50033 10.3248 10.8617 8.98215 12.5236 9.00093C14.1666 9.01032 15.4998 10.3529 15.4998 11.996C15.5092 13.6578 14.1572 15.0098 12.4954 15.0098Z",
    fill: "#354EB7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.23df29300c51d55c4e5d38b24074f0f3.svg";
export { ForwardRef as ReactComponent };